import { z } from 'zod';

/**
 * Friends contracts. The friends feature is request/accept (Discord-style):
 * one user sends a request, the other accepts or declines.
 *
 * Routes (server/src/routes/friends.ts):
 *   GET    /api/me/friends            → { friends, incoming, outgoing }
 *   POST   /api/me/friends { userId } → send a request (or accept an incoming one)
 *   POST   /api/me/friends/:userId/accept  → accept an incoming request
 *   DELETE /api/me/friends/:userId    → decline / cancel / unfriend (idempotent)
 *
 * Only the POST body needs validation; the rest carry the peer id in the path.
 */
export const sendFriendRequestSchema = z.object({
  userId: z.string().cuid(),
});

export type SendFriendRequestInput = z.infer<typeof sendFriendRequestSchema>;
